import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class EntityService {

  entities$: BehaviorSubject<any>;
  stackColors$: BehaviorSubject<any>;

  constructor(private http: HttpClient,
    private snackBar: MatSnackBar) { 
    this.entities$ = new BehaviorSubject(null);
    this.stackColors$ = new BehaviorSubject(null);
  }

  loadEntities(accountId:number,versionId:number) {
    
    this.entities$.next({"loading":true,data:[]});

    let params = new HttpParams()
    .set('accountid', accountId.toString())
    .set('versionid', versionId.toString())

    this.http.get("/api/data/entities",{ params }).subscribe(
      (response: any) => {
        let rtn = response;

        // update the 'displayorder' field with the value from 'dorder'
        // this is just so we can use select * on server side and overide the displayorder 
        // field if it is blank
        rtn.forEach(x => {
          x["displayorder"] = x["dorder"];          
        });

        this.entities$.next({"loading":false,data:rtn});
      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get entity');
        console.log(error);
      }
    );
  }

  updateEntity(data:object){

    // put on the spinner
    let olddata = this.entities$.getValue().data;
    this.entities$.next({"loading":true,data:olddata, updateOrDelete: true});

    // turn the data object into form data to post
    let body = new HttpParams();
    Object.keys(data).forEach(x => {
      body = body.append(x,data[x]);
    })

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return new Promise((resolve) => {
      this.http.post("/api/data/entities", body.toString(), {headers: headers})
      .subscribe(
      (response: any) => {

        if(response.success){
          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row
          const rtnid = response["id"];
          const rtndata = response["data"][0];

          let data = this.entities$.getValue().data;
          let found = false;

          data.forEach((x,i) => {
            if(x["id"]==rtnid){
              found = true;
              data[i] = rtndata;
            }
          });

          if(!found) data.push(rtndata);

          // publish the new data
          // console.log(data)
          this.entities$.next({"loading":false,data:data});
          resolve(response);

        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        let message="Unable to update the Entity";
        resolve(message);
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );
      })
  }

  updateEntitySort(darray:any){

    // save the sort values if they get changed - don't put on spinner or
    // update the front end - the data is already updated
  
    darray.forEach(data => {
        
      // turn the data object into form data to post
        let body = new HttpParams();
        Object.keys(data).forEach(x => {
          body = body.append(x,data[x]);
        })
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        this.http.post("/api/data/entities", body.toString(), {headers: headers})
        .subscribe(
          (response: any) => {
    
            if(!response.success){
              console.log('Unable to update the enitity sort order');
            }
    
          }, (error: any) => {
            let message="Unable to update the Entity"
            let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
            console.log(message + " > " + JSON.stringify(error));
    
            setTimeout(() => {
              document.location.reload();
            },1000)
          }
        )
      
    });
  }


  // Update the sort order value for an id in the data - without saving to database
  updateEntitySortOrder(id,val){

    let data = this.entities$.getValue().data;

    data.forEach((x,i) => {
      if(x["id"]==id){
        x["displayorder"] = val;
      }
    });
    this.entities$.next({"loading":false,data:data});

  }

  deleteEntity(data:object){

    // put on the spinner
    let olddata = this.entities$.getValue().data;
    this.entities$.next({"loading":true,data:olddata, updateOrDelete: true});

    // turn the data object into form data to post
    let body = new HttpParams().append("id",data["id"]).append("accountid",data["accountid"]);
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const options = {
      headers:headers,
      body: body
    }

    this.http.delete("/api/data/entities", options)
    .subscribe(
      (response: any) => {

        if(response.success){
          // get the id of the deleted row and remove that from the data
          const rtnid = response["id"];                  
          let data = this.entities$.getValue().data;
          data = data.filter(x => (x["id"] != rtnid));
        
          // publish the new data
          this.entities$.next({"loading":false,data:data});


        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        let message="Unable to delete the Entity"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );

  }

  loadStackColors() {
    this.stackColors$.next({ loading: true, data: [] });
    this.http.get('/api/data/framenames').subscribe((res: any) => {
      this.stackColors$.next({ loading: false, data: [...res] });
    }, (err: any) => {
      console.log('Unable to get stack colors');
      console.log(err);
    });
  }
}
